import { logEvent } from '../api/submissionService';

const pendingLogs = [];
let flushTimer = null;

const FLUSH_INTERVAL = 5000;

const flush = () => {
  if (pendingLogs.length === 0) return;
  const batch = pendingLogs.splice(0);
  logEvent({ events: batch, timestamp: new Date().toISOString() });
};

const scheduleFlush = () => {
  if (!flushTimer) {
    flushTimer = setTimeout(() => {
      flushTimer = null;
      flush();
    }, FLUSH_INTERVAL);
  }
};

export const recordEvent = (examId, studentName, action, details = {}) => {
  const event = {
    examId,
    studentName,
    action,
    details,
    timestamp: new Date().toISOString(),
    userAgent: navigator.userAgent
  };
  pendingLogs.push(event);
  scheduleFlush();
  return event;
};

export const recordAnswerChange = (examId, studentName, questionIndex, selectedIndex, questionText) => {
  return recordEvent(examId, studentName, 'ANSWER_CHANGED', {
    questionIndex,
    selectedIndex,
    questionText: questionText?.substring(0, 100)
  });
};

export const recordTabSwitch = (examId, studentName) => {
  return recordEvent(examId, studentName, 'TAB_SWITCH');
};

export const recordViolation = (examId, studentName, type) => {
  return recordEvent(examId, studentName, 'VIOLATION', { violationType: type });
};

export const recordExamStart = (examId, studentName) => {
  return recordEvent(examId, studentName, 'EXAM_STARTED');
};

export const recordExamSubmit = (examId, studentName) => {
  return recordEvent(examId, studentName, 'EXAM_SUBMITTED');
};

export const flushLogs = () => {
  if (flushTimer) {
    clearTimeout(flushTimer);
    flushTimer = null;
  }
  flush();
};

window.addEventListener('beforeunload', flushLogs);
